// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"d7f9a20a","271":"1f618f59","304":"d7eb550b","453":"419a5d54","718":"3630bf33"}[chunkId] + ".chunk.js";
};